import * as React from 'react';

import Grid from '@mui/material/Grid';

import monetizeYourGames from '@app/imageAssets/homePage/Monetize_Diagram_2x.png';

import { MonetizeCardStackSection } from './MonetizeCardStackSection';
import { useIntersectionObserver } from './utils';

function MonetizeGames() {
  const { isIntersecting, ref } = useIntersectionObserver();

  return (
    <Grid
      container={true}
      justifyContent={'center'}
      className={'home-page__monetize-container background-white max-container'}
    >
      <Grid
        item={true}
        xs={10}
        md={5}
        lg={4}
        className={`home-page__monetize-header-box max-screen
        `}
      >
        <div className={`fade-in-section ${isIntersecting ? 'is-visible' : ''}`} ref={ref}>
          <h1 data-qa="home-page__main-title">Monetize your games on the Skillz Platform</h1>
          <p>
            Skillz offers you a complete solution to help your business thrive. We make it easier so
            that you can focus on what you do best &ndash; create great games.
          </p>
        </div>
      </Grid>

      <MonetizeCardStackSection />
      {/* <MonetizeCardDetailsSection /> */}
      <Grid item={true} xs={10} lg={8} className="home-page__monetize-diagram-box">
        <img
          src={monetizeYourGames}
          className="home-page__monetize-your-games-diagram"
          alt="Monetize your skillz games"
        />
        <p className="home-page__monetize-your-games-diagram-text">
          Check out our&nbsp;
          <a
            className="home-page__monetize-your-games-diagram-link"
            href="https://docs.skillz.com/docs/welcome"
            target="_blank"
            rel="noopener noreferrer"
          >
            developer documentation
          </a>
          &nbsp;and&nbsp;
          <a
            className="home-page__monetize-your-games-diagram-link home-page__monetize-your-games-diagram-link-reverse"
            href="https://docs.skillz.com/docs/api-reference"
            target="_blank"
            rel="noopener noreferrer"
          >
            API reference
          </a>
          &nbsp;to learn more.
        </p>
      </Grid>
    </Grid>
  );
}

export { MonetizeGames };
